import {
  AccessTimeFilled,
  FlightLand,
  HistoryOutlined,
  Luggage,
  LuggageOutlined,
  TaskAlt,
  ThumbDownAlt,
  ThumbDownAltOutlined
} from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { memo, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import useRouteContext from "../../../../../hooks/useRouteContext";
import SidebarRoundedItem from "../../../components/SidebarRoundedItem";
import CreationFab from "./components/CreationFab";

const TravelsSidebar = ({ expanded }) => {
  const { role } = useRouteContext();

  const [params, setParams] = useSearchParams();

  const travelsFilter = params.get("travelsFilter") || "all";

  const handleFilterChange = useCallback(
    (filter) => () => {
      params.set("travelsFilter", filter);
      setParams(params);
    },
    [params, role]
  );

  if (!role) return;

  return (
    <>
      <Box mb={2} pl={0.1}>
        <CreationFab role={role} expanded={expanded} />
      </Box>
      <div>
        <SidebarRoundedItem
          disableLink
          isSelected={travelsFilter === "all"}
          Icon={LuggageOutlined}
          ActiveIcon={Luggage}
          title={"Todas"}
          showTooltip={!expanded}
          onClick={handleFilterChange("all")}
        />
        <SidebarRoundedItem
          disableLink
          isSelected={travelsFilter === "available"}
          Icon={TaskAlt}
          ActiveIcon={TaskAlt}
          title={"Disponíveis"}
          showTooltip={!expanded}
          onClick={handleFilterChange("available")}
        />
        <SidebarRoundedItem
          disableLink
          isSelected={travelsFilter === "pending"}
          Icon={HistoryOutlined}
          ActiveIcon={AccessTimeFilled}
          title={"Em aprovação"}
          showTooltip={!expanded}
          onClick={handleFilterChange("pending")}
        />
        <SidebarRoundedItem
          disableLink
          isSelected={travelsFilter === "rejected"}
          Icon={ThumbDownAltOutlined}
          ActiveIcon={ThumbDownAlt}
          title={"Rejeitadas"}
          showTooltip={!expanded}
          onClick={handleFilterChange("rejected")}
        />
        <SidebarRoundedItem
          disableLink
          isSelected={travelsFilter === "finished"}
          Icon={FlightLand}
          ActiveIcon={FlightLand}
          title={"Finalizadas"}
          showTooltip={!expanded}
          onClick={handleFilterChange("finished")}
        />
      </div>
    </>
  );
};

export default memo(TravelsSidebar);
